import type { IUseCase } from 'shared-kernel';
import type { ISessionRepository } from '../../../domain/ports';
import type { ListSessionsData, SessionsListResult } from '../../dto/dtos';

export class ListSessionsUseCase implements IUseCase<ListSessionsData, SessionsListResult> {
  constructor(
    private readonly sessionRepository: ISessionRepository,
  ) {}

  async execute(input: ListSessionsData): Promise<SessionsListResult> {
    const response = await this.sessionRepository.listSessions(input);

    if (!response.succes || !response.data) {
      throw new Error(response.message || 'Impossible de recuperer les sessions');
    }

    return response.data;
  }
}
